import { Component, OnInit, HostListener } from '@angular/core';
//import { PlatformLocation } from '@angular/common';
import { Location } from "@angular/common";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
	title = 'app works!';

	constructor(
		//location: PlatformLocation,
		private location: Location,
		private router: Router
	) {
		/*location.onPopState(() => {
			//this.router.navigateByUrl('/multicomponent');
			history.forward();
		});*/

		const navEndEvents$ = this.router.events
		.pipe(
			filter(event => event instanceof NavigationEnd)
		);

		navEndEvents$.subscribe((event: NavigationEnd) => {
			gtag('config', 'G-KXFW4TC3JF', {
				'page_path': event.urlAfterRedirects
			});
		});
	}

	ngOnInit(){
		/*this.location.subscribe(x => {
			history.forward();
		});*/
		//
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		console.log('Back button pressed');
		history.forward();
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/app.component.ts